import { render } from "./userEdit.vue?vue&type=template&id=61362999"
import script from "./userEdit.vue?vue&type=script&lang=js"
export * from "./userEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__